export default __webpack_public_path__ + "static/panels-98f6c00cec86011d6c21bc83dcde7770.png";